import { LoanFormat } from './LoanFormat';

export enum ProductType {
    /**
     * ePress related
     */
    ENEWS = 'ENEWS',
    EMAGAZINE = 'EMAGAZINE',

    /**
     * eBook related
     */
    ECOMIC = 'ECOMIC',
    INTERACTIVE_EBOOK = 'INTERACTIVE_EBOOK',

    /**
     * fallback
     */
    OTHER = 'OTHER'
}

export const ProductTypes: Record<LoanFormat, ProductType[]> = {
    [LoanFormat.eAudiobooks]: [],
    [LoanFormat.eBooks]: [ProductType.ECOMIC, ProductType.INTERACTIVE_EBOOK],
    [LoanFormat.eMagazines]: [ProductType.ENEWS, ProductType.EMAGAZINE],
    [LoanFormat.ePress]: [ProductType.ENEWS, ProductType.EMAGAZINE],
    [LoanFormat.eMagazineIssues]: [],
    [LoanFormat.ePressIssues]: []
};

export const parseProductType = (raw: string | null | undefined): ProductType | undefined => {
    if (typeof raw !== 'string' || raw.trim() === '') {
        return undefined;
    }

    const normalized = raw.trim().toLowerCase().replaceAll(' ', '_').replaceAll('_', '');
    switch (normalized) {
        case 'enews':
            return ProductType.ENEWS;
        case 'emagazines':
        case 'emagazine':
            return ProductType.EMAGAZINE;
        case 'ecomic':
        case 'ecomics':
            return ProductType.ECOMIC;
        case 'interactiveebook':
        case 'interactiveebooks':
            return ProductType.INTERACTIVE_EBOOK;
        default:
            return ProductType.OTHER;
    }
};

export const parseProductTypeByLoanFormat = (
    loanFormat: LoanFormat | undefined,
    raw: string | null | undefined
): ProductType | undefined => {
    if (!loanFormat || typeof raw !== 'string') {
        return undefined;
    }

    const productType = parseProductType(raw);
    return ProductTypes[loanFormat].find(key => key === productType);
};

export const isProductType = (value: any): value is ProductType => {
    return typeof value === 'string' && Object.values(ProductType).includes(value as ProductType);
};

export function mapProductTypeToRequestKey(productType: ProductType): string {
    switch (productType) {
        case ProductType.EMAGAZINE:
            return 'EMAGAZINE';
        case ProductType.ENEWS:
            return 'ENEWS';
        case ProductType.ECOMIC:
            return 'ECOMIC';
        case ProductType.INTERACTIVE_EBOOK:
            return 'INTERACTIVE_BOOK';
        default:
            return 'OTHER';
    }
}

export function formatProductType(productType: ProductType): string {
    switch (productType) {
        case ProductType.ENEWS:
            return 'eNews';
        case ProductType.EMAGAZINE:
            return 'eMagazine';
        case ProductType.ECOMIC:
            return 'eComic';
        case ProductType.INTERACTIVE_EBOOK:
            return 'Interactive eBook';
        default:
            return 'other';
    }
}
